export default function isPrimitiveType(value: unknown): boolean {
    return value !== Object(value);
}
